import { Skeleton } from '@mui/material';
import { VIDEO_JS_AUDIO_PLAYER_HEIGHTS, VideoJsAudioPlayerSize } from './VideoJsAudioPlayer';

export type VideoJsAudioPlayerSkeletonProps = {
  /** Must match the {@link VideoJsAudioPlayer} size so layout does not jump. */
  size?: VideoJsAudioPlayerSize;
};

/**
 * Placeholder that matches {@link VideoJsAudioPlayer} height and corner radius so layout
 * does not jump while the audio source is prepared.
 */
export function VideoJsAudioPlayerSkeleton({ size = 'medium' }: VideoJsAudioPlayerSkeletonProps) {
  return (
    <Skeleton
      variant="rounded"
      height={VIDEO_JS_AUDIO_PLAYER_HEIGHTS[size]}
      width="100%"
      sx={{ display: 'block', borderRadius: size === 'large' ? '12px' : '10px' }}
    />
  );
}
